import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAccessBadge } from '@obvious.tech/constellation'

export const AccessBadge = defineEntity('AccessBadge', {
  endpoint: 'accesscontrol/api/AccessBadge',
  schema: SNoop<IAccessBadge>(),
})
